import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map, type Observable } from 'rxjs';
import { TPSError } from '../api/api.models';
import { ExternalDataService } from '../external-data/external-data.service';

export class ECommError {
  static readonly ApplePayTransactionCancelled = new ECommError('panTokenGeneration.applePayTransactionCancelled');

  private constructor(public readonly translateKey: string) {}
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {

  private readonly $activeTpsErrors = new BehaviorSubject<TPSError[]>([]);
  private readonly $activeEcommErrors = new BehaviorSubject<ECommError[]>([]);
  private readonly $errorMessagesVisible = new BehaviorSubject(true);

  readonly $tpsErrors = this.visible(this.$activeTpsErrors);
  readonly $ecomErrors = this.visible(this.$activeEcommErrors);

  constructor(private externalDataService: ExternalDataService) {
    this.externalDataService.$showErrorMessages.pipe(distinctUntilChanged()).subscribe((show) => {
      this.$errorMessagesVisible.next(show);
    });
  }

  private visible<T>(source: BehaviorSubject<T[]>): Observable<T[]> {
    return combineLatest([source, this.$errorMessagesVisible]).pipe(
      map(([errors, show]) => (show ? errors : [])),
    );
  }

  clearTpsErrors() {
    this.$activeTpsErrors.next([]);
  }

  handleApiError(error: any) {
    if (!(error instanceof HttpErrorResponse)) {
      console.error('Unhandled unknown error.');
      return;
    }

    const tspError = error.error as TPSError;
    if (!tspError.responseCodeDescription && !tspError.responseCodeName) {
      console.error('Unhandled unknown error.');
      return;
    }

    this.$activeTpsErrors.next(this.$activeTpsErrors.value.concat(tspError));
    this.externalDataService.sendParentErrorResponse(tspError, error.status);
  }

  handleAppleCancellation() {
    this.$activeEcommErrors.next(this.$activeEcommErrors.value.concat(ECommError.ApplePayTransactionCancelled));
  }
}
